import { useState } from "react"
import "../Styles/Component/ProductCard.css"
import {AiFillStar, AiOutlineStar} from "react-icons/ai"

const ProductCard = ({name, img, rating, prevPrice, price}) => {
    const rate = Math.round(rating)

    
    return <>
        <section className="productCard">
            <div className="discount">{Math.round((price/prevPrice)*100)}%</div>
            <img src={img} alt="" />
            <div className="productDetails">
                <h3>{name}</h3>
                <div className="price">
                    <p className="slashed">${prevPrice}</p>
                    <p>${price}</p>
                </div>
                    {
                        rate === 5 ?
                        <div className="rating">
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                        </div> : 
                        rate === 4 ? 
                        <div className="rating">
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiOutlineStar/>

                        </div> : 
                        rate === 3 ? 
                        <div className="rating">
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>

                        </div> : 
                        rate === 2 ? 
                        <div className="rating">
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>

                        </div> : 
                        <div className="rating">
                            <AiFillStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>
                            <AiOutlineStar/>

                        </div>
                    }
            </div>

        </section>

    </>

}

export default ProductCard